/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react';
import styled from "@emotion/styled";
import Warning from '../../img/warning.svg';
import ShowModal from '../modal/ShowModal';


type MaintenanceModalProps = {
    show: boolean;
}

const Container = styled.div`
    max-width:600px;
    width:98%;
    margin:auto;
    border-radius:10px;
    background:white;
    box-shadow:0 3px 10px rgba(0,0,0,.3);
`
const Title = styled.h4`
    max-width: 70%;
`;
const WarningContainer = styled.div`
    border-radius: 12px;
    border: 1px solid #E09400;
    background: #FFECBA;
    box-shadow: 0px 16px 20px -8px rgba(17, 12, 34, 0.10);
    display: flex;
    align-items: flex-start;
    padding: 8px;
    p{
        color: #110C22;
        font-family: "telefonicaregular", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
    }
`;



const MaintenanceModal: FC<MaintenanceModalProps> = ({ show }) => {

    const modalMessage = "Estimado cliente, nuestra página de pagos estará en mantenimiento programado desde el sábado 11 de octubre a las 7:00 p.m. hasta el domingo 12 de octubre a las 7:00 a.m.. Durante este tiempo el servicio no estará disponible. Lo invitamos a realizar su pago luego de este horario. Gracias por su comprensión y preferencia"

    return (
        <ShowModal
            onClose={() => { }}
            reset={true}
            show={show}
        >
            <Container className={"p-3 p-md-4"}>
                <div className={"text-center pb-3 d-flex justify-content-center flex-column align-items-center"}>
                    <Title className={"fb"}>Mantenimiento programado</Title>
                </div>
                <WarningContainer>
                    <img src={Warning} alt="" className={"mb-3 mb-md-0 mx-2 mt-1"} />
                    <p>
                        {modalMessage}
                    </p>
                </WarningContainer>
            </Container>
        </ShowModal>
    )
}

export default React.memo(MaintenanceModal);
